import GlobalVariable from '../global/global-variable'

// 添加标签
const addGpsTagApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/add";

// 删除标签信息
const deleteGpsTagApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/delete";

// 查询标签信息
const searchGpsTagApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/search";
// 查询标签信息
const findByDidApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/findByDid";
// 查询标签信息
const fingByBindTypeApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/findByBindType";

// 查询标签ID
const searchGpsTagIdApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/searchTagId";

// 查询标签轨迹
const searchGpsTagTrackerApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/searchTrack";
const searchDeviceTrackerApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/searchDeviceTrack";

// 查询未加入的标签
const searchUnAddGpsTagApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/findUnAdd";

// 彻底删除
const completelyDeleteApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/completelyDelete";

// 修改短定位间隔
const changeShortIntervalApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/changeShortInterval";

// 添加标签编号
const addGpsTagIdApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/addTagBatch";

// 批量修改标签编号
const batchUpdateGpsTagIdsApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/batchUpdateGpsTagIds";

// 修改标签配置
const updateGpsTagConfigApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/updateConfig";

// 查询标签日志
const searchGpsTagLogApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/log/search";

// 更新Sim卡信息
const updateSimApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/updateSim";

// 更新Sim卡信息
const updateIccidApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/updateIccid";

// 查询Sim卡信息
const searchSimApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/searchSim";

// 恢复Sim卡信息
const restoreSimApi = GlobalVariable.BASE_PATH + "/rest/gps/tag/restoreSim";

export default {
    addGpsTagApi,
    deleteGpsTagApi,
    searchGpsTagApi,
    // 查询标签信息
    findByDidApi,
    // 查询标签信息
    fingByBindTypeApi,
    searchGpsTagIdApi,
    searchGpsTagTrackerApi,
    searchDeviceTrackerApi,
    searchUnAddGpsTagApi,
    completelyDeleteApi,
    changeShortIntervalApi,
    batchUpdateGpsTagIdsApi,
    addGpsTagIdApi,
    updateGpsTagConfigApi,
    searchGpsTagLogApi,
    updateSimApi,
    updateIccidApi,
    searchSimApi,
    restoreSimApi
}



// WEBPACK FOOTER //
// ./src/request/api-gps-tag.js